import { defineStore } from 'pinia'

export const userAvatarStore = defineStore('useravatar', {
	state: () => ({
		options: {
			refresh: true,
		}
	}),
	actions: {
	}
	// getters
	// actions
})
